import { clearAccountHeader, setAccountHeader, setBusinessContext } from '@/http/axios';
import { PATH_DASHBOARD } from '@/routes/paths';

// Conta e negócio gravados juntos antes de uma recarga só. Trocar um de cada vez
// recarregaria duas vezes, e a primeira carga sairia com a conta nova e o negócio
// da conta anterior. A recarga vai para o Dashboard e não para a URL atual, porque
// a tela aberta pode não existir na outra conta.
export const switchAccountAndBusiness = ({ account, businessId }) => {
  if (account.isOwn) {
    clearAccountHeader();
  } else {
    setAccountHeader(account.ownerId);
  }

  setBusinessContext(businessId);
  window.location.assign(PATH_DASHBOARD.general.home);
};
